export enum AppIconSizeEnum {
    CUSTOM_17PX = '17px',
    CUSTOM_18PX = '18px',
    CUSTOM_26PX = '26px',
    SMALL = '24px',
    MEDIUM = '30px',
    CUSTOM_32PX = '32px',
    LARGE = '48px',
    INHERIT = 'inherit',
    CSS_VARIABLE = 'none'
}
